import { useCmsFields } from '@/cms/content';

export function useCmsFaq<T extends { q: string; a: string }>(items: readonly T[], prefix = 'information.faq.items') {
  const cms = useCmsFields(items.flatMap((item, index) => [
    { key: `${prefix}.${index}.q`, label: `Pytanie ${index + 1}`, section: 'Pytania i odpowiedzi', kind: 'text' as const, defaultValue: item.q, required: true },
    { key: `${prefix}.${index}.a`, label: `Odpowiedź ${index + 1}`, section: 'Pytania i odpowiedzi', kind: 'textarea' as const, defaultValue: item.a, required: true, optionalMarker: true },
  ]));
  return {
    ...cms,
    items: items.map((item, index) => ({ ...item, cmsKey: `${prefix}.${index}`, q: cms.value(`${prefix}.${index}.q`), a: cms.value(`${prefix}.${index}.a`) })),
  };
}
